import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Message, Title } from "../../components";
import Handler from "./Modules/Handler";
import { useStore } from "../../store";
import Table from "./Modules/Table";
import { Wrap } from "./styles";
import { useDidMountEffect } from "../../utils/custom";
import { useCookies } from "react-cookie";
import moment from "moment";
import dayjs from "dayjs";
import useKeyPress from "../../utils/custom/useKeyPress";

const History = () => {
  const {
    HistoryStore: {
      startDate,
      endDate,
      setRows,
      setStartDate,
      setEndDate,
      setSearchText,
      gridOption: { page, rowsPerPage, loading, totalCount },
      setGridOption,
      onPageChange,
    },
  } = useStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  useEffect(() => {
    if (localStorage.getItem("role") === "viewer" && pathname === "/history") {
      return setOpen(true);
    }
    setGridOption({
      page: cookies.hPage ? Number(cookies.hPage) : 0,
      rowsPerPage: cookies.hRowsPerPage ? Number(cookies.hRowsPerPage) : 20,
    });
    setStartDate(
      cookies.hStartDate
        ? cookies.hStartDate
        : dayjs().subtract(1, "month").toDate()
    );
    if (loading) setTimeout(() => setRows(), 500);
  }, []);

  useDidMountEffect(() => {
    setCookie("hPage", page, { path: "/", expires });
    setTimeout(() => setRows(), 500);
  }, [page]);

  useDidMountEffect(() => {
    setCookie("hRowsPerPage", rowsPerPage, { path: "/", expires });
    setCookie("hStartDate", startDate, { path: "/", expires });
    setGridOption({
      page: cookies.hPage ? Number(cookies.hPage) : 0,
      totalCount: 0,
    });

    setTimeout(() => setRows(), 500);
  }, [startDate, endDate, rowsPerPage]);

  const handleKeyDown = (event: KeyboardEvent) => {
    let element: HTMLElement = event.target as HTMLElement;
    if (element) {
      if (element.querySelector("div")?.id !== "openedDlg") {
        switch (element.tagName) {
          case "INPUT":
          case "LI":
          case "TEXTAREA":
          case "BUTTON":
            break;
          default:
            if (event.key === "ArrowRight") {
              const pageCount = Math.ceil(totalCount / rowsPerPage);
              if (pageCount > page + 1) {
                onPageChange(page + 1);
                event.preventDefault();
              }
            } else if (event.key === "ArrowLeft" && page >= 1) {
              onPageChange(page - 1);
              event.preventDefault();
            }
            break;
        }
      }
    }
  };

  useKeyPress(["ArrowRight", "ArrowLeft"], handleKeyDown);

  return (
    <Wrap>
      <Title label="History" isDivider />
      <Handler />
      <Table />
      <Message open={open} handleClose={handleClose} />
    </Wrap>
  );
};

export default observer(History);
